import {Component, Input, OnInit} from '@angular/core';
import {ApplicationResource, CatalogResource} from "../../core/modules/openapi";
import {CommonService} from "../../services/common.service";

@Component({
  selector: 'app-application-outline',
  imports: [],
  templateUrl: './application-outline.component.html',
  styleUrl: './application-outline.component.sass'
})
export class ApplicationOutlineComponent implements OnInit {
  @Input() applicationResource: ApplicationResource;
  protected insurers: Map<string, CatalogResource>;

  constructor(private readonly commonService: CommonService) {
  }

  ngOnInit(): void {
    this.commonService.getInsurersMap().subscribe(insurers => {
      if (insurers) this.insurers = insurers;
    });
  }
}
